// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"0d173958","711":"29c19426"}[chunkId] + ".chunk.js";
};